import {StringUtils} from "components/src/utils/StringUtils";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Placement} from 'react-bootstrap/types';

interface TruncateProps {
    value? : string
    maxLength : number
    placement?: Placement
    className? : string
}

export const Truncate = ({value, maxLength, placement = "top", className} : TruncateProps) =>
{
    if (value === undefined || value === null || value.length < maxLength)
    {
        return (
            <span className={className}>{value}</span>
        )
    }
    else {
        return (
            <OverlayTrigger
                placement={placement}
                overlay={
                    <Tooltip>
                        {value}
                    </Tooltip>
                }
            >
                <span className={className}>{StringUtils.truncate(value, maxLength)}</span>
            </OverlayTrigger>
        )
    }
}
